import AuthorizationContext     from 'auth/keycloak-instance';
import useTranslate             from 'app/common/hooks/translate';

const WelcomeMessage = props => {
    const t         = useTranslate();
    
    /* const checkForValidProducts = () => {
        return AuthorizationContext.user.authorizedProducts.find( item => item.name === 'pms' || item.name === 'inventory' );
    } */ 

    return (
        <div className="welcome-message">
            <h1>{ t('Welcome') } { AuthorizationContext.user.profile.firstName }!</h1>
            <div className="navigation-menu-container">
                { /* eslint-disable-next-line */ }
                <a href="https://status.simprasuite.com/" target="_blank">{ 'Status' }</a>
                
                { /*
                    checkForValidProducts()
                        
                        ?   <a href={ window.REACT_APP_SIMPRA_REPORTS_URL } target="_blank">{ t('Simpra_Reports') }</a>
                        :   null*/
                }
            </div>
        </div>
    )
}

export default WelcomeMessage